import React from "react";

const NotFound = () => {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="card">
          <h5>Error!!!</h5>
          <p> Page not found</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
